export type AdminRole = 'support' | 'abuse_analyst' | 'platform_admin' | 'founder'

const ROLE_LEVEL: Record<AdminRole, number> = {
  support: 1,
  abuse_analyst: 2,
  platform_admin: 3,
  founder: 4,
}

export function getAdminRole(): AdminRole | null {
  const token = localStorage.getItem('admin_token')
  if (!token) return null
  try {
    const base64 = token
      .split('.')[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')
    const payload = JSON.parse(window.atob(base64))
    // Superadmin role is stored in the `plan` claim by the current JWT helper.
    const role = payload.role || payload.plan
    if (role && role in ROLE_LEVEL) {
      return role as AdminRole
    }
  } catch {
    // ignore malformed token
  }
  return null
}

export function canAccess(role: AdminRole | null, minRole: AdminRole): boolean {
  if (!role) return false
  return ROLE_LEVEL[role] >= ROLE_LEVEL[minRole]
}
